/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
'use client'

import NotificationIsland from 'components/shared/NotificationIsland'
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from 'react'
import * as signalR from '@microsoft/signalr'
import store from 'store'
import { baseURL } from 'services/baseUrl'
import { useQueryClient } from 'react-query'
import BaseService from 'services/BaseService'

const NotificationContext = createContext(undefined)

export const UploadDocIAProvider = ({ children }) => {
  const [notification, setNotification] = useState(null)
  const [hasNotification, setHasNotification] = useState(false)
  const [hasDocuments, setHasDocuments] = useState(null)
  const [documentoId, setDocumentoId] = useState(null)
  const [empresaIdPendencias, setEmpresaIdPendencias] = useState(null)
  const [isProcessado, setIsProcessado] = useState(false)
  const [statusRefreshKey, setStatusRefreshKey] = useState(0)
  const [isForceSendModalOpen, setIsForceSendModalOpen] = useState(false)
  const [havePendencias, setHavePendencias] = useState(null)
  const [documentosEmpresaDataa, setDocumentosEmpresaDataa] = useState([])

  useEffect(() => {
  if (!empresaIdPendencias) {
    return
  }

 const ObterPendenciaEnvio = async () => {
    const response = await BaseService.get(
      `/Document/ListarBloqueadosEnvio`,
      {
        params: { empresaId: empresaIdPendencias },
      },
    )
    setHavePendencias(response.data)
    return response.data
  }

  ObterPendenciaEnvio()
}, [empresaIdPendencias, documentoId, statusRefreshKey])

  const [resumoRefreshKey, setResumoRefreshKey] = useState(0)
  const refreshResumoMatera = useCallback(() => {
    setResumoRefreshKey((k) => k + 1)
  }, [])

  function select(state) {
    return state.auth.session.token
  }
  const token = select(store.getState())

  const notify = useCallback((type, message) => {
    setNotification({ type, message })
    setHasNotification(true)

    if (type !== 'loading' && type !== 'uploading') {
      setTimeout(() => {
        setNotification(null)
        setHasNotification(false)
      }, 2000)
    }
  }, [])

  const startLoading = useCallback((message) => {
    setNotification({ type: 'loading', message })
    setHasNotification(true)
  }, [])

  const removeNotification = useCallback(() => {
    setNotification(null)
    setHasNotification(false)
  }, [])

  const queryClient = useQueryClient()

  useEffect(() => {
    if (!token || !documentoId) return

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${baseURL}/hubs/documento-ia`, {
        accessTokenFactory: () => token,
        withCredentials: false,
      })
      .withAutomaticReconnect()
      .build()
      console.log("aaaa", connection)
    connection.on('documento_ia_status_atualizado', async (data) => {
      const status = data?.status ?? ''

      notify('success', `Status Documento IA atualizado: ${status}`)
      if (status === 'Concluido') {
        setIsProcessado(true)
        setStatusRefreshKey((k) => k + 1)

        await queryClient.refetchQueries(['documentosEmpresa'], {
          active: true,
          exact: false,
        })
      }
      setStatusRefreshKey((k) => k + 1)

      await queryClient.invalidateQueries({queryKey: ['documentosEmpresa']})
    })
    connection
      .start()
      .then(() => {
        connection.invoke('AssinarDocumento', documentoId)
        console.log('Status Documento IA Invoke')
      })
      .catch((err) => {
        console.error('Erro ao conectar ao hub IA', err)
        notify('error', 'Erro ao conectar ao hub IA')
      })

    return () => {
      connection
        .stop()
        .catch((err) => console.error('Erro ao desconectar do hub IA', err))
    }
  }, [documentoId, notify, token /*, refreshResumoMatera */])

  return (
<NotificationContext.Provider
  value={{
    notify,
    startLoading,
    removeNotification,
    hasNotification,
    hasDocuments,
    setHasDocuments,
    documentoId,
    setDocumentoId,
    refreshResumoMatera,
    isForceSendModalOpen,
    setIsForceSendModalOpen,
    statusRefreshKey,
    setStatusRefreshKey,
    setHavePendencias,
    havePendencias,
    setEmpresaIdPendencias,
    setDocumentosEmpresaDataa,
    documentosEmpresaDataa,
  }}
>
      {children}

      <NotificationIsland
        type={notification?.type}
        message={notification?.message}
        hasNotification={hasNotification}
      />
    </NotificationContext.Provider>
  )
}

export const useUploadDocIA = () => {
  const context = useContext(NotificationContext)
  if (!context)
    throw new Error('useUploadDocIA must be used within a UploadDocIAProvider')
  return context
}
